import { defineComponent as _defineComponent } from 'vue'
import { CurrencyCode } from '@/models/currencyCode';
import { mastersService } from '@/services/masters.service';
import { uniqueId } from '@/utils/misc';
import { computed } from 'vue';
import { useI18n } from '@/composables/i18n';
import { ValidationRules } from '@/utils/validation';
import useVuelidate from '@vuelidate/core';


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyCodesSelect',
  props: {
    value: null,
    rules: { default: () => ({}) },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ((e: 'input', value: string) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: string | null, rules: ValidationRules, disabled: boolean };





const { t } = useI18n();

const componentId = uniqueId();

const selectedCurrencyCode = computed<string | null>({
  get() {
    return props.value ?? null;
  },
  set(newValue) {
    emit('input', newValue!);
  },
});
const validations = {
  currencyCode: props.rules,
};
const v$ = useVuelidate(validations, {
  currencyCode: selectedCurrencyCode,
});

const currencyCodes = computed((): CurrencyCode[] =>
  mastersService.store.getCurrencyCodes(),
);

const required = computed(() => 'required' in props.rules);

const validationMessage = computed(
  () => v$.value.currencyCode?.$errors[0]?.$message,
);

return { __sfc: true,props, emit, t, componentId, selectedCurrencyCode, validations, v$, currencyCodes, required, validationMessage }
}

})